var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoLeftTool1Active(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0549 16.0088C30.0549 19.5049 28.7636 22.7024 26.6642 25.162C24.0728 28.1575 20.2604 30.0549 16 30.0549C13.5755 30.0549 11.2916 29.44 9.30636 28.3595C4.92299 25.979 1.95389 21.3408 1.95389 16.0088C1.95389 14.5945 2.16471 13.2241 2.56001 11.9153C3.35059 9.28876 4.89663 6.99605 6.94338 5.28311C8.73538 3.74586 10.9051 2.68296 13.3032 2.21739C14.1729 2.0417 15.0777 1.95386 16.0088 1.95386C18.7495 1.95386 21.2969 2.74445 23.4579 4.08845C27.4284 6.57441 30.0725 10.9929 30.0725 16.0088H30.0549Z",
    fill: "white",
    stroke: "#247499",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0549 16.0087C30.0549 19.5048 28.7636 22.7023 26.6642 25.1619L22.6322 23.3172L25.3378 19.0832L24.6965 13.2856L20.6733 12.574L17.3528 7.84806L23.4403 4.07959C27.4109 6.56555 30.0549 10.9841 30.0549 15.9999V16.0087Z",
    fill: "#E5F0E3",
    stroke: "#247499",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.36784 21.6571L10.9929 25.6276L9.29757 28.3595C4.9142 25.979 1.9451 21.3409 1.9451 16.0088C1.9451 14.5945 2.15592 13.2241 2.55122 11.9153L6.96973 13.3296L11.3619 12.5038L12.9694 17.4318L9.37663 21.6483L9.36784 21.6571Z",
    fill: "#E5F0E3",
    stroke: "#247499",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2857 2.20874L12.9606 6.82051L10.0706 7.44419C10.0706 7.44419 8.42793 6.30223 6.9346 5.27447C8.7266 3.73721 10.8963 2.67431 13.2944 2.20874H13.2857Z",
    fill: "#E5F0E3",
    stroke: "#247499",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLeftTool1Active);
export default __webpack_public_path__ + "static/media/ico-left-tool-1-active.89e02ef2eefdc6fabeddd24850288871.svg";
export { ForwardRef as ReactComponent };